import styled from '@grebban/style-system-react';

import { type TransformHeadingOutput } from 'libs/wordpress/utils/transformHeading';
import { type ButtonProps } from 'components/Button';
import { HeroComponent } from './HeroComponent';
import { PostsContainerToAlgoliaArticle } from '../ArticlesPromotion/PostsContainerToAlgoliaArticle';

const Wrapper = styled('div')`
    display: flex;
    flex-direction: column;
    gap: 32px;
    border-bottom: 1px solid var(--color-neutrals-200);
`;

export interface ArticleHeroComponentProps extends Record<string, unknown> {
    heading?: TransformHeadingOutput;
    button?: ButtonProps;
    articleSelection: {
        ids: number[];
        tag: string;
    } | null;
}

export const ArticleHeroComponent = ({ heading, button, articleSelection }: ArticleHeroComponentProps) => {
    if (!articleSelection?.ids) {
        return null;
    }

    return (
        <Wrapper gap={['24px', null, null, null, '40px']}>
            <PostsContainerToAlgoliaArticle ids={articleSelection?.ids}>
                {({ response }) => (
                    <HeroComponent
                        response={response}
                        customTag={articleSelection.tag}
                        button={button}
                        heading={heading}
                    />
                )}
            </PostsContainerToAlgoliaArticle>
        </Wrapper>
    );
};
